import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { ROUTES } from "@repo/core/routes";

export const NewTransactionPaymentOptionsController = () => {
  const { navigateBack, customNavigate, currentRouteConfig } =
    useNewTransactionFlow();
  const { isMobile } = useDimensions();
  const { setIsInstallmentsPayment, setSelectedInstallment } =
    useNewTransactionStore();

  const menuActionItems: MenuActionItemProps[] = [
    {
      title: "Á vista",
      onPress: () => {
        setIsInstallmentsPayment(false);
        setSelectedInstallment(undefined);
        customNavigate({
          to: ROUTES.newTransactionReview,
          previous: ROUTES.newTransactionPaymentOptions
        });
      }
    },
    {
      title: "Parcelado",
      onPress: () => {
        setIsInstallmentsPayment(true);
        customNavigate({
          to: ROUTES.newTransactionInstallments,
          previous: ROUTES.newTransactionPaymentOptions
        });
      }
    }
  ];

  return {
    isMobile,
    menuActionItems,
    handleBack: navigateBack,
    title: currentRouteConfig.title
  };
};
